import Blocks from "./blocks";
import Editor from "./editor";
import Preview from "./preview";

export default function({category, subcategory}){
    if(category) {
        if(subcategory) {
            if(subcategory === "preview") {
                return <Preview category={category} />
            }
            return <div>Page Not Found</div>
        }
        return <Editor category={category} />
    }
    return <Blocks />
}